export const socialMediaLinksData = {
  active: true,
  key: 'social-links',
  value: [
    {
      active: true,
      icon: 'https://magento-test.innovaksa.net/media/json/images/slider/s/v/svgviewer-output_5_.png',
      'mobile-position': '1',
      position: '1',
      'title-ar': 'Title Ar',
      'title-en': 'title en',
      url: 'https://www.facebook.com/innovahc',
    },
    {
      active: true,
      icon: 'https://magento-test.innovaksa.net/media/json/images/slider/s/v/svgviewer-output_8_.png',
      'mobile-position': '2',
      position: '2',
      'title-ar': 'test',
      'title-en': 'test',
      url: 'https://wa.me/+966920008391',
    },
    {
      active: true,
      icon: 'https://magento-test.innovaksa.net/media/json/images/slider/s/v/svgviewer-output_6_.png',
      'mobile-position': '3',
      position: '3',
      'title-ar': 'test',
      'title-en': 'test',
      url: 'https://www.instagram.com/innovahc',
    },
    {
      active: true,
      icon: 'https://magento-test.innovaksa.net/media/json/images/slider/s/v/svgviewer-output_4_.png',
      'mobile-position': '4',
      position: '4',
      'title-ar': 'test',
      'title-en': 'test',
      url: 'https://www.snapchat.com/add/innovahc',
    },
    {
      active: true,
      icon: 'https://magento-test.innovaksa.net/media/json/images/slider/s/v/svgviewer-output_7_.png',
      'mobile-position': '5',
      position: '5',
      'title-ar': 'test',
      'title-en': 'test',
      url: 'https://twitter.com/innovahc',
    },
  ],
};
